import { render, staticRenderFns } from "./new-recommendation.vue?vue&type=template&id=10fbe6d1&"
import script from "./new-recommendation.vue?vue&type=script&lang=js&"
export * from "./new-recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports